import { DateTime } from 'luxon'

const CONTINENT_ONLY = 1
const CITY_ONLY = 2
const CONTINENT_STATE_CITY = 3

export const getTimeZoneName = (zone: string): string => {
  const DateInSpecifiedTimeZone = DateTime.fromObject({}, { zone: zone })
  const shortOffset = DateInSpecifiedTimeZone.toFormat('ZZ')
  const unabbreviatedOffsetName = DateInSpecifiedTimeZone.toFormat('ZZZZZ')

  return `(GMT${shortOffset}) ${unabbreviatedOffsetName}`
}

export const getExtendedTimeZoneName = (zone: string): string => {
  const timeZoneOffsetAndNamedOffset = getTimeZoneName(zone)

  const zoneNameWithSpaces = zone.replace(/_/g, ' ')
  const areaNames = zoneNameWithSpaces.split('/')

  if (timeZoneOffsetAndNamedOffset.includes(areaNames[1])) {
    areaNames.splice(1, 1)
  }

  switch (areaNames.length) {
    case CONTINENT_ONLY:
      return timeZoneOffsetAndNamedOffset
    case CITY_ONLY:
      return `${timeZoneOffsetAndNamedOffset} - ${areaNames[1]}`
    case CONTINENT_STATE_CITY:
      return `${timeZoneOffsetAndNamedOffset} - ${areaNames[2]}, ${areaNames[1]}`
    default:
      return ''
  }
}
